import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PaintModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Paint brush handle */}
      <path
        d="M19 3L13 9"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Brush ferrule (metal part) */}
      <path
        d="M13 9L10 12"
        stroke={color}
        strokeWidth={strokeWidth + 1}
        strokeLinecap="round"
      />
      {/* Brush bristles with paint */}
      <path
        d="M10 12C8 14 6 16 5 18C4 19.5 5.5 21 7 20C9 19 11 17 13 15"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      />
      {/* Paint drop */}
      <circle cx="6" cy="18" r="1.5" fill={color} />
    </BaseIcon>
  ),
);

PaintModeIcon.displayName = 'PaintModeIcon';
